import React, { useState } from 'react';
import { Button, Text, useTheme } from 'react-native-paper';
import { StyleSheet, View, ScrollView, TouchableOpacity } from 'react-native';

export const BannerContent = ({ displayArr, onClose }) => {
	const theme = useTheme();
	
	// Define color constants to avoid lint errors
	const BORDER_COLOR = 'rgba(0,0,0,0.05)';
	const LABEL_COLOR = '#666666';
	
	const styles = StyleSheet.create({
		outerContainer: {
			display: 'flex',
			flexDirection: 'column',
			gap: 12,
			padding: 20,
			paddingBottom: 8,
			backgroundColor: theme.colors.white,
			opacity: 1,
			borderRadius: 12,
		},
		innerContainer: {
			display: 'flex',
			flexDirection: 'column',
		},
		sectionTitle: {
			fontFamily: theme.fonts.medium.fontFamily || 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
			fontSize: 18,
			fontWeight: 'bold',
			color: theme.colors.primary,
			textTransform: 'uppercase',
			letterSpacing: 1,
		},
		detailRow: {
			display: 'flex',
			flexDirection: 'row',
			gap: 10,
			paddingVertical: 6,
			borderBottomWidth: 1,
			borderBottomColor: BORDER_COLOR,
		},
		labelText: {
			width: '40%',
			color: LABEL_COLOR,
			fontSize: 16,
			fontFamily: theme.fonts.medium.fontFamily || 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
			fontWeight: '200',
		},
		valueText: {
			width: '60%',
			color: theme.colors.drawerText,
			fontSize: 16,
			fontFamily: theme.fonts.medium.fontFamily || 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
			fontWeight: '200',
		},
		showAllButton: {
			width: '100%',
			borderRadius: 8,
			marginTop: 8,
			elevation: 0,
			backgroundColor: theme.colors.transparent,
			display: 'flex',
			justifyContent: 'center'
		},
		showAllText: {
			color: theme.colors.primary,
			textAlign: 'center',
			fontSize: 20,
			fontWeight: 600
		},
		headerContainer: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center'
		}
	});
	const personTypes = ['Client', 'Court', 'Defendant', 'Attorney', 'Paralegal'];
	const dateTypes = ['IncidentDate', 'SOLDate'];
	const [showAll, setShowAll] = useState(false);
	const useArr = displayArr.slice(0, showAll || displayArr.length < 7 ? displayArr.length : 7);
	
	return <View style={styles.outerContainer}>
		<View style={styles.headerContainer}>
			<Text style={styles.sectionTitle}>Case Details</Text>
			{/* Using default styling. If needing a change, switch to a component consistent between ios and android */}
			<Button onPress={() => onClose()}>X</Button>
		</View>
		<ScrollView style={styles.innerContainer}>
			{
				useArr.map((x) => 
					<View style={styles.detailRow} key={x.name}>
						<Text style={styles.labelText} numberOfLines={1} ellipsizeMode='tail'>{x.name}</Text>
						<Text style={styles.valueText} numberOfLines={1} ellipsizeMode='tail'>
							{
								(personTypes.indexOf(x.type) > -1
									? x.value.Name
									: dateTypes.indexOf(x.type) > -1
										? (new Date(x.value)).toLocaleDateString()
										: x.value) ||
                                '—'
							}
						</Text>
					</View>
				)
			}
		</ScrollView>
		{!showAll && displayArr.length > 7 &&
		<TouchableOpacity style={styles.showAllButton} onPress={() => setShowAll(true)}>
			<Text style={styles.showAllText}>SHOW ALL DETAILS</Text>
		</TouchableOpacity>
		}
	</View>;
};